import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,{attrs:{"id":"inspire"}},[_c(VContent,[_c(VContainer,{staticClass:"fill-height",attrs:{"fluid":""}},[_c(VRow,{attrs:{"align":"center","justify":"center"}},[_c(VCol,{attrs:{"cols":"12","sm":"10","md":"4"}},[_c(VCard,{attrs:{"outlined":""}},[_c(VImg,{staticClass:"mx-auto mt-10",attrs:{"max-height":"200","max-width":"200","src":_vm.logoB}}),_c(VCardText,{staticClass:"text-center"},[_c('p',[_vm._v("Your account has not been verified.")]),_c('p',[_vm._v("Please wait for admin to approve your account.")]),_c('a',{on:{"click":_vm.gotoLogin}},[_vm._v("Click here to go back to login page.")])])],1)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }